module.exports = __webpack_public_path__ + "h5/img/logo6.890fbee1.png";